import { SkeletonBar, TextPassage } from '@petsmart-ui/sparky';

import { usePurchaseFormState } from '@/entities/purchase-form';
import { StatusText } from '@/shared/ui';

import { useSthDeliveryDetails } from '../../model';

export const SthDetails = () => {
    const { isSubmitSuccessful } = usePurchaseFormState();

    const {
        isInStock,
        isLoading,
        poBoxText,
        stockStatusText,
        nextAutoshipText,
        minimumQuantityText,
        nextAutoshipSubmittedText,
        isPrecrawl,
    } = useSthDeliveryDetails();

    return (
        <div className="delivery-details__sth" data-testid="sth-delivery-details">
            {isLoading && stockStatusText && <SkeletonBar className="delivery-details__status-skeleton--sm" />}
            {!isLoading && stockStatusText && (
                <StatusText size="lg" variant={isInStock ? 'success' : 'error'}>
                    {stockStatusText}
                </StatusText>
            )}

            {poBoxText && <TextPassage data-testid="po-box">{poBoxText}</TextPassage>}

            {isPrecrawl && (
                <>
                    {nextAutoshipText && !isSubmitSuccessful && (
                        <StatusText size="lg" variant={isInStock ? 'success' : 'error'}>
                            {nextAutoshipText}
                        </StatusText>
                    )}

                    {nextAutoshipSubmittedText && isSubmitSuccessful && (
                        <TextPassage size="lg">{nextAutoshipSubmittedText}</TextPassage>
                    )}
                </>
            )}

            {minimumQuantityText && <TextPassage data-testid="minimum-qty">{minimumQuantityText}</TextPassage>}
        </div>
    );
};
